import React from 'react';
import InlineFilterPills from '../InlineFilterPills';
import { formatLanguage } from 'constants/languages';

interface InlineLanguagePillsProps {
  value: string[];
  availableOptions: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
}

const InlineLanguagePills: React.FC<InlineLanguagePillsProps> = ({
  value,
  availableOptions,
  onChange,
  disabled = false,
}) => {
  // Create display map for available options
  const displayMap = availableOptions.reduce((acc, lang) => {
    acc[lang] = formatLanguage(lang);
    return acc;
  }, {} as Record<string, string>);

  return (
    <InlineFilterPills
      value={value}
      availableOptions={availableOptions}
      onChange={onChange}
      displayMap={displayMap}
      disabled={disabled}
      minSelection={1}
      maxDisplay={4}
      placeholder="+ Lang"
      showAddButton={true}
    />
  );
};

export default InlineLanguagePills;